import { render, staticRenderFns } from "./queryExaminationPaperList.vue?vue&type=template&id=019c56c0&scoped=true"
import script from "./queryExaminationPaperList.vue?vue&type=script&lang=js"
export * from "./queryExaminationPaperList.vue?vue&type=script&lang=js"
import style0 from "./queryExaminationPaperList.vue?vue&type=style&index=0&id=019c56c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c56c0",
  null
  
)

export default component.exports